import React from 'react';
import './Spinner.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  fullPage?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', label, fullPage = false, className = '' }) => {
  const spinner = (
    <div className={`pro-spinner-wrap ${className}`} role="status" aria-live="polite">
      <div className={`pro-spinner pro-spinner--${size}`} aria-hidden="true" />
      {label && <span className="pro-spinner-label">{label}</span>}
    </div>
  );

  if (!fullPage) return spinner;

  return <div className="pro-loading-fullpage">{spinner}</div>;
};

export default Spinner;
